import { FirmwareService } from "../_services";
import { Helper } from "../_helpers/helper";

const state = { all: {} };

const actions = {

};

const mutations = {

};

export const firmware = {
  namespaced: true,
  state,
  actions,
  mutations
};
